module.exports = "../../static/pages/AppTermsAndConditions.html";


//////////////////
// WEBPACK FOOTER
// ./static/pages/AppTermsAndConditions.html
// module id = 763
// module chunks = 1